export const SUBSCRIPTION_PRICING = [
  { value: 100, price: 8900 },
  { value: 500, price: 4900 },
  { value: 1000, price: 2900 },
  { value: 2000, price: 1990 },
];
